import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLPATypeOfIncidentPage } from 'gwce-capability-fnol-pa-react-ext';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

function FNOLRTTypeOfIncidentPage(props) {
    return <FNOLPATypeOfIncidentPage {...props} />;
}

FNOLRTTypeOfIncidentPage.propTypes = wizardProps;
FNOLRTTypeOfIncidentPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};
export default withRouter(withAuthenticationContext(FNOLRTTypeOfIncidentPage));
